import { Alert, Layout } from "components";
import { Footer } from "components/Footer";
import { FormAlert } from "components/FormAlert/index";
import { FormStep } from "components/FormStep";
import { InfoContent } from "components/InfoContent";
import { Loading } from "components/Loading";
import { NewAlert } from "components/NewAlert";
import { SingIn } from "components/SingIn";
import { SbModal } from "components/ui_kit/Modal";
import React, { useContext, useEffect, useState } from "react";
import styles from "styles/home/home.module.scss";
import step2Img from "../../assets/img/step_2.svg";
import { AlertsContext } from "../../contexts/alert";

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function Home() {
    const {
        isLogged,
        loading,
        type,
        setType,
        data,
        setData,
        show,
        setShow,
        title,
        subtitle,
        alerts,
        handleCreateWishList,
        handleRemoveWishListItemById,
        handleEditWishListItemById,
        editData,
    } = useContext(AlertsContext);

    const [stepForm, setStepForm] = useState(1);
    const [showForm, setShowForm] = useState(false);
    const [sizeModal, setSizeModal] = useState("modal_category");

    const handleEditAlert = (item) => {
        setData(item);
        setType("edit");
        setShow(true);
        setShowForm(true);
        setStepForm(item?.product?.category === "outros" ? 2 : 1);
        setSizeModal("modal_form");
        localStorage.removeItem("editID");
    };

    useEffect(() => {
        editData && handleEditAlert(editData);
    }, [editData]);

    return (
        <>
            <Layout title={title} subtitle={subtitle}>
                {isLogged ? (
                    <div
                        className={[
                            styles.content,
                            alerts?.length ? false : styles[`content_center`],
                        ].join(" ")}
                    >
                        {!loading ? (
                            alerts?.length ? (
                                alerts?.map((item, l) => (
                                    <Alert
                                        key={item._id}
                                        id={item._id}
                                        data={item}
                                        deleteAlert={(id) => {
                                            handleRemoveWishListItemById(
                                                id,
                                                item
                                            );
                                        }}
                                        editAlert={() => {
                                            handleEditAlert(item);
                                        }}
                                    />
                                ))
                            ) : (
                                <SingIn showButton={false} />
                            )
                        ) : (
                            <Loading />
                        )}
                        <div hidden={loading}>
                            <NewAlert
                                handleNewAlert={() => {
                                    setType("create");
                                    setShow(true);
                                    setShowForm(false);
                                    setSizeModal("modal_category");
                                }}
                            />
                        </div>
                    </div>
                ) : (
                    <SingIn showButton={true} />
                )}
            </Layout>
            <Footer />
            <SbModal
                className={[
                    styles.mobile_modal,
                    styles[sizeModal],
                    type === "create" && alerts.length >= 3 && styles["size"],
                ].join(" ")}
                show={show}
                handleClose={() => {
                    setShow(false);
                    setShowForm(false);
                    setSizeModal("modal_category");
                }}
            >
                {type === "create" && alerts.length >= 3 ? (
                    <InfoContent
                        title="Você atingiu o limite máximo de 3 alertas criados"
                        imgSrc={step2Img}
                        hasButton
                        mainButtonLabel="Voltar para os meus alertas"
                        secondaryButtonLabel="Quero ser prime"
                        onClickMainbutton={() => setShow(false)}
                    />
                ) : (
                    <FormStep
                        valueForm={(value) => {
                            setStepForm(value);
                            setSizeModal("modal_form");
                            setShowForm(true);
                        }}
                        step={stepForm}
                        show={showForm}
                    >
                        {stepForm == 1 && (
                            <FormAlert
                                open={show}
                                aoEnviar={(data) => {
                                    if (type === "edit") {
                                        return handleEditWishListItemById(
                                            data.id,
                                            data.product
                                        );
                                    }
                                    handleCreateWishList(data.product);
                                }}
                                data={data}
                                type={type}
                                handleClose={(value) => {
                                    setSizeModal("modal_category");
                                    setShowForm(value);
                                }}
                                formCategory={"carros-motos"}
                            />
                        )}

                        {stepForm == 2 && (
                            <FormAlert
                                open={show}
                                aoEnviar={(data) => {
                                    if (type === "edit") {
                                        return handleEditWishListItemById(
                                            data.id,
                                            data.product
                                        );
                                    }
                                    handleCreateWishList(data.product);
                                }}
                                data={data}
                                type={type}
                                handleClose={(value) => {
                                    setSizeModal("modal_category");
                                    setShowForm(value);
                                }}
                                formCategory={"outros"}
                            />
                        )}
                    </FormStep>
                )}
            </SbModal>
        </>
    );
}
